module.exports = __webpack_public_path__ + "static/media/launch-party-stcl.5886a602.png";